type NumericTextProps = {
	value: string | number | null | undefined
}

// Renders each number (digits plus the thousands separators and decimal point between them) in
// the `type-numeric` role (Plex Mono) so the separators are as clear as the digits and columns
// align. Signs, currency symbols and units stay in the surrounding Plex Sans. The text content
// is unchanged.
const NumericText = ({ value }: NumericTextProps) => {
	if (value === null || value === undefined) return null

	return (
		<>
			{String(value).split(/(\d+(?:[.,]\d+)*)/).map((part, index) =>
				index % 2 === 1 ? (
					<span key={index} className='type-numeric' data-testid='numeric-digits'>
						{part}
					</span>
				) : (
					part
				)
			)}
		</>
	)
}

export default NumericText
